var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-677 -141)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 15,
    transform: "translate(677 141)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450.617 -301.602)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.565,443.538h-3.743a.937.937,0,0,0-.936-.936H233.01a.938.938,0,0,0-.939.936h-3.753a.939.939,0,0,0,0,1.878h11.247a.939.939,0,1,0,0-1.878Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.915,444.81v9.232a2.134,2.134,0,0,0,2.137,2.136h7.1a2.132,2.132,0,0,0,2.13-2.136V444.81Zm3.186,8.6a.6.6,0,0,1-.6.6.6.6,0,0,1-.587-.6V447.7a.593.593,0,0,1,.587-.6.6.6,0,0,1,.6.6Zm3.1,0a.6.6,0,1,1-1.2,0V447.7a.6.6,0,0,1,1.2,0Zm3.09,0a.6.6,0,1,1-1.192,0V447.7a.6.6,0,1,1,1.192,0Z",
    transform: "translate(0.344 1.424)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.a886f0fc096eac606659468c389f3b91.svg";
export { ForwardRef as ReactComponent };